/*
 * @Author       : 萝卜兄台
 * @Date         : 2023-03-01 13:34:24
 * @LastEditors  : 萝卜兄台\thund leili995997651@qq.com
 * @LastEditTime : 2023-05-22 15:31:59
 * @FilePath     : \gas_station_platform_web\src\utils\shared.ts
 * @Description  : 通用函数方法
 */
import { refresh } from "@/api/login";
import { notification, Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import regular from "@/utils/static";
import dayjs from "dayjs";

// 如果accessToken 过期 更新token
const holdUp = () => {
  return new Promise((resolve, reject) => {
    refresh()
      .then((res: any) => {
        //@ts-ignore
        localStorage.setItem("accessToken", res.data.accessToken);
        //@ts-ignore
        localStorage.setItem("refreshToken", res.data.refreshToken);
        //@ts-ignore
        localStorage.setItem("user", JSON.stringify(res.data.user));
        resolve(res);
      })
      .catch((err: any) => {
        reject();
      });
  });
};
/** 通用的 通知提醒 */
const errorReminder = (type: any, title: string, text: string) => {
  let notifications: any = notification;
  notifications[type]({
    message: title,
    description: text,
    style: {
      width: "330px",
      marginLeft: `${400 - 600}px`,
    },
    duration: 3,
  });
};
/** 删除提示 */
const deleteConfirm = () => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: "删除提示?",
      icon: createVNode(ExclamationCircleOutlined),
      content: "数据删除之后,将无法恢复,确认删除该数据吗?",
      onOk() {
        resolve(true);
      },
      onCancel() { },
    });
  });
};
/** 重启提示 */
const restartConfirm = (title: string, text: string) => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: title,
      icon: createVNode(ExclamationCircleOutlined),
      content: text,
      onOk() {
        resolve(true);
      },
      onCancel() { },
    });
  });
};
/** 递归处理 permissions */
const recursive = (data: any) => {
  try {
    if (data.length > 0) {
      data.map((e: any) => {
        if (e.permissions.length > 0) {
          recursive(e.permissions);
        } else {
          e.permissions = "";
        }
      });
      return data;
    }
    return data;
  } catch (error) {
    return data;
  }
};
/** 处理路由 */
const dealRouter = (router: any, data: any) => {
  return new Promise((resolve, reject) => {
    try {
      let definitionRouter = [];
      let systemRouter = router.options.routes[2].children;

      //拥有的权限 path
      let userMenu = data.user.menus; // JSON.parse(localStorage.getItem("user")).menus;
      for (let i = 0; i < systemRouter.length; i++) {
        if (systemRouter[i].children || systemRouter[i].children > 0) {
          // 有子项
          let son;
          let pared = userMenu.filter((e: any) => e === systemRouter[i].path);
          if (pared && pared.length > 0) {
            let temp = JSON.parse(JSON.stringify(systemRouter[i]));
            temp.children = [];
            for (let j = 0; j < systemRouter[i].children.length; j++) {
              let sonPared = userMenu.filter(
                (e: any) => e === systemRouter[i].children[j].path
              );
              if (sonPared && sonPared.length > 0) {
                temp.children.push(systemRouter[i].children[j]);
              }
            }
            definitionRouter.push(temp);
          }
        } else {
          let compared = userMenu.filter(
            (e: any) => e === systemRouter[i].path
          );
          if (compared && compared.length > 0) {
            definitionRouter.push(systemRouter[i]);
          }
        }
      }
      resolve(definitionRouter);
    } catch (error) {
      reject();
    }
  });
};
/** vite 静态图片引入 */
const getImageUrl = (name: string) => {
  return new URL(`../assets/${name}`, import.meta.url).href;
};
/** 判断按钮权限---是否有权限 */
const btnPermissionIdentify = (word: string) => {
  // @ts-ignore
  let user = JSON.parse(localStorage.getItem("user") || "{}");
  try {
    if (user?.permissions.indexOf(word) > -1) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
/** AILabel 类型转换 */
const aiMode = (e: string) => {
  switch (e) {
    // 矩形
    case "rectangle":
      return "RECT";
    // 四边形
    case "quad":
      return "POLYGON";
    // 多边形
    case "polygon":
      return "POLYGON";
    // 直线
    case "line":
      return "LINE";
    // 圆
    case "circle":
      return "CIRCLE";
    default:
      return e;
  }
};
/** 全局唯一标识符号 */
const uuid = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};
/** 转换成秒 */
const turnInSeconds = (e: string) => {
  let seconds =
    Number(e.split(":")[0]) * 60 * 60 +
    Number(e.split(":")[1]) * 60 +
    Number(e.split(":")[2]) / 1 +
    Number(e.split(":")[3]) / 1000 +
    0.1;
  return seconds.toFixed(4);
};
/** 防抖函数 */
const throttle = (func: any, delay: number) => {
  let timeOut: any;
  return function (...args) {
    clearTimeout(timeOut); //一定要清除定时器
    timeOut = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
/** 训练状态 */
const trainStatusFind = (status: string) => {
  try {
    let arr = regular.trainingStatus.find((e) => e.value === status);
    return arr || { label: "", value: "", color: "" };
  } catch (error) {
    return { label: "", value: "", color: "" };
  }
};

const computingPlatform = (status: string) => {
  try {
    let arr = regular.computingPlatform.find((e) => e.value === status);
    return arr || { label: "", value: "", color: "" };
  } catch (error) {
    return { label: "", value: "", color: "" };
  }
};
/** 类别 */
const targetFind = (status: string) => {
  try {
    let arr = regular.targetType.find((e) => e.value === status);
    return arr || { label: "", value: "", color: "" };
  } catch (error) {
    return { label: "", value: "", color: "" };
  }
};
/** 用用场景 */
const modelTypeFind = (status: string) => {
  try {
    let arr = regular.modelType.find((e) => e.value === status);
    return arr || { label: "", value: "", color: "" };
  } catch (error) {
    return { label: "", value: "", color: "" };
  }
};
/** 用用场景 */
const exportStatusFind = (status: string) => {
  try {
    let arr = regular.exportStatus.find((e) => e.value === status);
    return arr || { label: "", value: "", color: "" };
  } catch (error) {
    return { label: "", value: "", color: "" };
  }
};

export const getTime = (dateTimeStamp: any) => {
  const before = new Date(dateTimeStamp).getTime();
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  // const year = month * 12
  const now = new Date().getTime();
  const timeDiff = now - before;
  // dateTimeStamp存在
  if (before <= 0) return;
  if (timeDiff < 0) return;
  // const yearBefore = timeDiff / year
  const monthBefore = timeDiff / month; // 几个月
  // const weekBefore =timeDiff / (7 * day)  // 几周
  const dayBefore: any = timeDiff / day; // 几天
  const hourBefore: any = timeDiff / hour; // 小时
  // const minBefore =timeDiff / minute // 分钟
  if (monthBefore > 1) {
    // 大于一个月 显示年月日
    return dayjs(dateTimeStamp).format("YYYY年MM月DD日");
  }
  // else if(monthBefore>=1) {
  // 	return "" + parseInt(monthBefore) + "月前"
  // }
  // else if(weekBefore >= 1) {
  //   return  "" + parseInt(weekBefore) + "周前"
  // }
  else if (dayBefore >= 1) {
    return "" + parseInt(dayBefore) + "天前";
  } else if (hourBefore >= 1) {
    return "" + parseInt(hourBefore) + "小时前";
  }
  // else if(minBefore>=1) {
  // 	return ""+ parseInt(minBefore) +"分钟前"
  // }
  else return "刚刚";
};

/**
 * 获取时间差
 * @param timeStart
 * @param timeEnd
 */
export const getCostTimeString = (timeStart: any, timeEnd: any) => {
  const start = new Date(timeStart)
  const end = new Date(timeEnd)
  let timeCost = end.getTime() - start.getTime(); //时间差的毫秒数
  let days = Math.floor(timeCost / (24 * 3600 * 1000)); // 计算出相差天数
  //计算出小时数
  let leave1 = timeCost % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));
  //计算出相差分钟数
  let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000));
  //计算出相差秒数
  let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  let seconds = Math.round(leave3 / 1000);
  if (days > 0) {
    return days + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒";
  }
  if (hours > 0) {
    return hours + "小时" + minutes + "分钟" + seconds + "秒";
  }
  if (minutes > 0) {
    return minutes + "分钟" + seconds + "秒";
  }
  if (seconds > 0) {
    return seconds + "秒";
  }
  return minutes + "分钟" + seconds + "秒";
};

export default {
  holdUp,
  errorReminder,
  deleteConfirm,
  recursive,
  dealRouter,
  getImageUrl,
  btnPermissionIdentify,
  aiMode,
  uuid,
  turnInSeconds,
  throttle,
  trainStatusFind,
  targetFind,
  modelTypeFind,
  exportStatusFind,
  getTime,
  getCostTimeString,
  computingPlatform,
  restartConfirm
};
